<template>
  <u-button
    variant="outline"
    :icon="icon"
    @click="copyText()" :label="hasCopiedText ? labelCopied : label"
  />
</template>

<script setup>
  import {waitFor} from '~/utils/flow-control.js';

  const props = defineProps({
    text: String,
    label: {
      type: String,
      default: 'Copy Link'
    },
    labelCopied: {
      type: String,
      default: 'Link Copied!'
    },
    icon: {
      type: String,
      default: 'i-ri-link'
    }
  });

  const hasCopiedText = ref(false);
  async function copyText() {
    await usePermission('clipboard-read')
    const {copy} = useClipboard({legacy: true});
    copy(props.text);
    hasCopiedText.value = true;
    await waitFor(4000);
    hasCopiedText.value = false;
  }
</script>
